/**
 * SearchKeyboardContainer component.
 */
import styled from 'styled-components';
import withAnimation from '@shared/components/utils/hoc/withAnimation';

/**
 * Styled search keyboard container.
 */
const SearchKeyboardContainer = styled.div<React.CSSProperties>``;

export default withAnimation(SearchKeyboardContainer);
